/** Rosa MX chrome + auth + Personal. Merged into shared catalogs; other skins ignore unused keys. */
export const rosaMxI18n: Record<string, Record<string, string>> = {
  'es-MX': {
    'rosa.exitInvite.title': 'Invita a 1 amigo',
    'rosa.exitInvite.copy': 'Invita a un amigo que cumpla los requisitos de la actividad y recibe la recompensa del primer nivel.',
    'rosa.exitInvite.go': 'Invitar ahora',

    'rosa.act.agente': 'Agente',
    'rosa.act.canjear': 'Reembolso',
    'rosa.act.checkin': 'Check-in',
    'rosa.act.ganar200': 'Ganar $200',
    'rosa.act.invitacion': 'Invitación',
    'rosa.act.misterioso': 'Misterioso',
    'rosa.act.promocional': 'Promocional',
    'rosa.act.ranking': 'Ranking',
    'rosa.act.ruleta': 'Ruleta',
    'rosa.act.semana': 'Semana',
    'rosa.salary.title': 'VIP Salario',
    'rosa.salary.hero': '¡Usuarios VIP, reclamen sus recompensas de actualización y salario semanal!',
    'rosa.salary.heroSub': 'Recarga para desbloquear generosas recompensas',
    'rosa.salary.levelNow': 'Nivel actual: VIP {n}',
    'rosa.salary.upgradeSec': 'Recompensas de actualización',
    'rosa.salary.weekSec': 'Salario semanal',
    'rosa.salary.days': 'días',
    'rosa.salary.receive': 'Recibir',
    'rosa.salary.received': 'Recibido',
    'rosa.salary.locked': 'No desbloqueado',
    'rosa.salary.history': 'Historial',
    'rosa.salary.rule1': 'Cada semana recibirás un bono en efectivo según tu nivel VIP actual.',
    'rosa.salary.rule2': 'Cuanto más alto sea tu VIP, mayor será el bono semanal.',
    'rosa.salary.rule3': 'Los bonos se pueden reclamar después de las 5:00 a. m. todos los miércoles.',
    'rosa.salary.rule4': 'La plataforma se reserva el derecho a la interpretación final.',
    'rosa.act.vip': 'VIP',
    'rosa.checkpop.copy': 'Inicia sesión diariamente para recibir recompensas.',
    'rosa.checkpop.go': 'Ir al Check-in',
    'rosa.casino.empty': 'Sin juegos disponibles',
    'rosa.casino.games': 'Juegos',
    'rosa.casino.loadError': 'No se pudo cargar. Inténtalo de nuevo.',
    'rosa.casino.noResults': 'Sin resultados',
    'rosa.casino.search': 'Buscar',
    'rosa.casino.searchGame': 'Buscar juego',
    'rosa.casino.title': 'Casino',
    'rosa.search.title': 'Buscar',
    'rosa.search.prefix': 'Casino',
    'rosa.search.placeholder': 'Nombre del juego',
    'rosa.search.minChars': 'Por favor, ingrese al menos 3 caracteres',
    'rosa.search.history': 'Historial',
    'rosa.search.clearHistory': 'Borrar',
    'rosa.search.recommend': 'Recomendado',
    'rosa.search.empty': 'Sin resultados',
    'rosa.common.back': 'Volver',
    'rosa.common.backTop': 'Volver arriba',
    'rosa.common.loading': 'Cargando…',
    'rosa.common.retryLoad': 'No se pudo cargar',
    'rosa.dep.amount': 'valor',
    'rosa.dep.amountMin': 'valor(≥ {min})',
    'rosa.dep.amountRange': 'valor({min} ~ {max})',
    'rosa.dep.bonusOpt': 'Deposita ahora y obtén un bono de hasta:',
    'rosa.dep.bonusTip': 'Bono canjeable tras 1x apuestas válidas',
    'rosa.dep.completePay': 'Completa el pago',
    'rosa.dep.kindFirst': 'Primer depósito',
    'rosa.dep.kindRecharge': 'Recarga siguiente',
    'rosa.dep.invalidAmount': 'Monto inválido',
    'rosa.dep.invalidPayUrl': 'Enlace de pago inválido',
    'rosa.dep.loadMethodsFail': 'No se pudieron cargar los métodos de depósito',
    'rosa.dep.methods': 'Métodos de depósito',
    'rosa.dep.noChannel': 'No hay canales de depósito',
    'rosa.dep.receive': 'Recibirás',
    'rosa.dep.records': 'Registro de depósito',
    'rosa.dep.success': 'Depósito exitoso',
    'rosa.depRec.accumulated': 'Depósito Acumulado:',
    'rosa.depRec.empty': 'Sin registro de depósito',
    'rosa.depRec.fail': 'Fallo',
    'rosa.depRec.loading': 'Cargando...',
    'rosa.depRec.noMore': 'No hay más datos',
    'rosa.depRec.ok': 'Éxito',
    'rosa.depRec.pending': 'Pendiente',
    'rosa.depRec.range.last': 'Últimos {day} días',
    'rosa.depRec.range.seven_days': '7 días',
    'rosa.depRec.range.three_days': '3 días',
    'rosa.depRec.range.today': 'Hoy',
    'rosa.depRec.valor': 'Valor',
    'rosa.footer.community':
      '¡Bienvenido a la comunidad de {brand}! Comparte ideas, temas y participa con respeto. ¡Únete!',
    'rosa.home.catalogError': 'No se pudieron cargar los juegos. Inténtalo más tarde.',
    'rosa.home.emptyGames': 'Sin juegos disponibles',
    'rosa.home.more': 'Más',
    'rosa.lobby.hot': 'Caliente',
    'rosa.lobby.new': 'Nuevo',
    'rosa.redeem.busy': 'Canjeando…',
    'rosa.redeem.code': 'Código de canje',
    'rosa.redeem.empty': '¡No puede estar vacío!',
    'rosa.redeem.err.already': 'Ya canjeaste este código.',
    'rosa.redeem.err.device': 'Límite de canjes de este dispositivo alcanzado.',
    'rosa.redeem.err.exhausted': 'Este código se agotó.',
    'rosa.redeem.err.expired': 'Código expirado o aún no disponible.',
    'rosa.redeem.err.generic': 'La conexión de red ha expirado. Por favor, verifica tu conexión.',
    'rosa.redeem.err.invalid': 'Código inválido.',
    'rosa.redeem.err.ip': 'Límite de canjes de esta red alcanzado.',
    'rosa.redeem.headline': 'Canjea tu código de bono',
    'rosa.redeem.ok': 'Bono de $ {amount} acreditado.',
    'rosa.redeem.placeholder': 'Introduce tu código aquí',
    'rosa.redeem.submit': 'Canjear',
    'rosa.redeem.title': 'Código de bono',
    'rosa.ticker.withdraw': '{player} Acabas de retirar {amount} $',
    'rosa.wd.amountPlaceholder': 'Por favor ingresa el monto del retiro.',
    'rosa.wd.available': 'Puede retirarse',
    'rosa.wd.fieldAccount': 'Cuenta',
    'rosa.wd.fieldName': 'Ingresa tu nombre',
    'rosa.wd.history': 'Historial',
    'rosa.wd.invalidAmount': 'Monto inválido',
    'rosa.wd.loadFail': 'No se pudo cargar el retiro',
    'rosa.wd.note': '$50 Deposita en tu cuenta personal',
    'rosa.wd.payPassword': 'Contraseña de pago (6 dígitos)',
    'rosa.wd.records': 'Registro de retiro',
    'rosa.wd.rules': 'Reglas',
    'rosa.wd.rulesBody':
      'Los retiros del juego dependen de los límites de apuesta. Si no puedes retirar, juega más para aumentarlo. Contacta a soporte si necesitas ayuda.',
    'rosa.wd.spei': 'Para retirar con SPEI, registra tu SPEI a través de la aplicación de tu banco.',
    'rosa.wdHist.amount': 'Valor',
    'rosa.wdHist.empty': 'Sin datos disponibles',
    'rosa.wdHist.order': 'Orden',
    'rosa.wdHist.refresh': 'Actualizar estado del retiro',
    'rosa.wdHist.status': 'Estado',
    'rosa.wdHist.time': 'Tiempo',
    'rosa.auth.brandWelcome': 'Bienvenido a',
    'rosa.auth.err.passwordFormat':
      '6 a 16 caracteres de longitud, números, letras mayúsculas y minúsculas, o caracteres especiales',
    'rosa.auth.err.passwordRequired': 'Por favor ingresa tu contraseña',
    'rosa.auth.err.phoneInvalid': 'Número de teléfono incorrecto',
    'rosa.auth.err.phoneLength': 'El número debe tener 10 dígitos',
    'rosa.auth.err.phoneRequired': 'Por favor ingresa tu número de teléfono',
    'rosa.auth.err.termsRequired': 'Por favor confirma esta opción.',
    'rosa.auth.hasAccount': '¿Ya tienes cuenta?',
    'rosa.auth.hidePassword': 'Ocultar contraseña',
    'rosa.auth.loginBusy': 'Entrando…',
    'rosa.auth.noAccount': '¿Aún no tienes cuenta?',
    'rosa.auth.phone': 'Número de teléfono',
    'rosa.auth.password': 'Contraseña',
    'rosa.auth.registerBusy': 'Registrando…',
    'rosa.auth.registerGift': 'Registrarse +$ 10 ~ 100',
    'rosa.auth.registerGiftAmount': 'Registrarse +$ {n}',
    'rosa.auth.registerGiftRange': 'Registrarse +$ {min} ~ {max}',
    'rosa.auth.remember': 'Recordar contraseña',
    'rosa.auth.showPassword': 'Mostrar contraseña',
    'rosa.auth.slogan': 'Te ofrecemos una experiencia de juego inigualable',
    'rosa.auth.terms': 'Acepto todas las políticas, términos de privacidad y confirmo que tengo al menos 18 años.',
    'rosa.common.close': 'Cerrar',
    'rosa.common.closeMenu': 'Cerrar menú',
    'rosa.common.copied': 'Copiado',
    'rosa.common.copyFail': 'No se pudo copiar',
    'rosa.common.copyId': 'Copiar ID',
    'rosa.common.home': 'Inicio',
    'rosa.common.menu': 'Menú',
    'rosa.float.bonus': 'WhatsApp bono',
    'rosa.float.promo': 'Promoción de recarga',
    'rosa.float.social': 'Telegram / WhatsApp',
    'rosa.header.bonus': '+$ 10 ~ 50',
    'rosa.header.bonusAmount': '+$ {n}',
    'rosa.header.bonusRange': '+$ {min} ~ {max}',
    'rosa.header.deposit': 'Depositar',
    'rosa.header.login': 'Entrar',
    'rosa.header.message': 'Mensaje',
    'rosa.header.register': 'Registrarse',
    'rosa.menu.addHome': 'Agregar a la pantalla de inicio',
    'rosa.menu.bonusCode': 'Código de bono',
    'rosa.menu.deposit': 'Recargar',
    'rosa.menu.free200': 'Gana $200 gratis',
    'rosa.menu.support': 'Soporte en vivo',
    'rosa.menu.withdraw': 'Retiro',
    'rosa.nav.aria': 'Navegación principal',
    'rosa.nav.bonus': 'Bonos',
    'rosa.nav.deposit': 'Depositar',
    'rosa.nav.personal': 'Personal',
    'rosa.nav.promotions': 'Promociones',
    'rosa.nav.withdraw': 'Retirar',
    'rosa.profile.bets': 'APUESTAS',
    'rosa.profile.currency': 'Moneda：',
    'rosa.profile.deposit': 'Depositar',
    'rosa.profile.depositRec': 'Recarga',
    'rosa.profile.withdrawRec': 'Retiro',
    'rosa.profile.guestHint': 'Por favor regístrate o inicia sesión primero.',
    'rosa.profile.guestWelcome': 'Bienvenido a',
    'rosa.profile.invite': 'Cofre de invitación',
    'rosa.profile.logout': 'Cerrar sesión',
    'rosa.profile.message': 'Mensaje',
    'rosa.profile.service': 'Atención al cliente',
    'rosa.profile.title': 'Personal',
    'rosa.profile.wheel': 'Rueda de la suerte',
    'rosa.cta.activate': 'Por activar',
    'rosa.cta.autoGrant': 'Se acredita automáticamente',
    'rosa.cta.claim': 'Cobrar',
    'rosa.cta.claimed': 'Cobrado',
    'rosa.cta.claimedVip': 'Recibido',
    'rosa.cta.enter': 'Entrar',
    'rosa.cta.locked': 'Bloqueado',
    'rosa.common.all': 'Todas',
    'rosa.common.claimFail': 'No se pudo cobrar',
    'rosa.common.claimedOk': 'Recompensa cobrada',
    'rosa.common.claimedOkAmount': 'Recompensa cobrada +{amount}',
    'rosa.common.claimedOkCoupon': 'Recompensa cobrada +{n}%',
    'rosa.common.details': 'Detalles',
    'rosa.common.empty': 'Sin datos',
    'rosa.common.next': 'Siguiente',
    'rosa.common.prev': 'Anterior',
    'rosa.promo.empty': 'Sin actividades',
    'rosa.engine.empty.misterioso': 'Sin misterioso',
    'rosa.engine.empty.promocional': 'Sin promocional',
    'rosa.engine.empty.semana': 'Sin semana',
    'rosa.engine.day': 'Día {n}',
    'rosa.engine.max': 'Máx. $ {n}',
    'rosa.engine.level': 'Nivel {n}',
    'rosa.engine.register': 'Registro',
    'rosa.engine.eventDetails': 'Detalles del evento:',
    'rosa.engine.goDeposit': 'Recarga ahora',
    'rosa.engine.reward': 'Recompensa',
    'rosa.rescue.pageTitle': 'Subsidio por pérdidas',
    'rosa.rescue.tabDaily': 'Pago de ayuda diario',
    'rosa.rescue.tabWeekly': 'Pago de ayuda semanal',
    'rosa.rescue.today': 'El subsidio de hoy',
    'rosa.rescue.hintDaily': 'Se podrá recoger a las {h}:00 del día siguiente.',
    'rosa.rescue.hintWeekly': 'Se podrá recoger a las {h}:00 del lunes.',
    'rosa.rescue.colLevel': 'Nivel',
    'rosa.rescue.colLoss': 'Cantidad de pérdida',
    'rosa.rescue.colRate': 'Subsidio',
    'rosa.rescue.rules': 'Reglas del evento:',
    'rosa.sign.chestHint': 'Al iniciar sesión consecutivamente, puedes recibir un cofre misterioso: máximo ???',
    'rosa.sign.collect': 'Recoger',
    'rosa.sign.level': 'Nivel actual: VIP{n}',
    'rosa.sign.lockedRound': 'No desbloqueado: {n} ronda de Check-in ({days} días en total)',
    'rosa.sign.reward': 'Recompensa',
    'rosa.game.login': 'Inicia sesión',
    'rosa.game.maint': 'Mantenimiento en curso.',
    'rosa.game.notFound': 'Juego no encontrado',
    'rosa.game.balanceTooLow': 'Saldo disponible inferior a 1. Recarga antes de entrar.',
    'rosa.guide.congrats': '🎉 ¡Felicidades! 🎉',
    'rosa.guide.win': 'El jugador [{player}] ganó {amount} en {game}. ¡Prueba tu suerte!',
    'rosa.guide.winPrefix': 'El jugador [{player}] ganó ',
    'rosa.guide.winSuffix': ' en {game}. ¡Prueba tu suerte!',
    'rosa.inv.hireTitle': 'GROUP ESTÁ CONTRATANDO',
    'rosa.inv.hireLead': 'Buscamos influencers y creadores de contenido',
    'rosa.inv.hireBody':
      'Si eres influencer o creador de contenido y buscas una oportunidad de trabajo estable, de largo plazo y con excelentes ingresos, comunícate con nosotros.',
    'rosa.inv.hireMode': 'MODALIDAD DE TRABAJO',
    'rosa.inv.hireModeBody':
      'Promoción en Instagram y Facebook, además de difusión en canales de WhatsApp y Telegram.',
    'rosa.inv.hireContact': 'CONTACTO',
    'rosa.inv.hireTelegram': 'Telegram: @CCmegaOne',
    'rosa.inv.subtext':
      'Invita a tus amigos a registrarse y completar su recarga para recibir una recompensa de hasta',
    'rosa.inv.tabHow': 'Cómo invitar',
    'rosa.inv.tabDaily': 'Invitación diaria',
    'rosa.inv.agentRank': 'Ranking de agentes',
    'rosa.inv.chest': 'Cofre',
    'rosa.inv.colReward': 'Obtenga recompensas',
    'rosa.inv.colValid': 'Invitar a usuarios válidos',
    'rosa.inv.condition': 'condición',
    'rosa.inv.recharge': 'Recarga',
    'rosa.inv.bets': 'Apuestas',
    'rosa.inv.copy': 'Copiar',
    'rosa.inv.copyHint': 'Copia el enlace de invitación y envíaselo a tus amigos.',
    'rosa.inv.copyLink': 'Enlace copiado',
    'rosa.inv.detailLead':
      '¡Invita a tus amigos y gana premios increíbles! Explora con nosotros 5000 juegos interactivos de entretenimiento populares en todo el mundo. Únete al Programa de Socios y obtén altas comisiones cuando tus amigos se registren y realicen su primer depósito.',
    'rosa.inv.detailRule':
      'Reglas de participación: Un amigo que se registre a través de tu enlace exclusivo y complete su primer depósito se agregará a tu lista de referidos válidos.',
    'rosa.inv.emailSubject': 'Invitación',
    'rosa.inv.flowInvite': 'Invitar',
    'rosa.inv.flowReward': 'Recompensa de {n}',
    'rosa.inv.guests': 'Invitados',
    'rosa.inv.loadFail': 'No se pudo cargar la invitación',
    'rosa.inv.payoutTip': 'Las recompensas se distribuirán a las 11:00 del día siguiente.',
    'rosa.inv.people': '{n} Persona',
    'rosa.inv.peopleMore': '> {n} personas',
    'rosa.inv.peopleRange': '{from} - {to} personas',
    'rosa.inv.posterHint': 'Escanea el código QR para unirte y empezar a ganar juntos.',
    'rosa.inv.posterLead': 'Regístrate y reciba',
    'rosa.inv.posterSave': 'Guardar imagen',
    'rosa.inv.posterSaving': 'Guardando…',
    'rosa.inv.posterSaved': 'Imagen descargada',
    'rosa.inv.posterSaveFail': 'No se pudo guardar la imagen. Inténtalo de nuevo.',
    'rosa.inv.posterLabel': 'Imagen de invitación {n}',
    'rosa.inv.posterFriends': 'Ayuda a tus amigos y gana premios en efectivo.',
    'rosa.inv.posterSub': 'Más de 5000 juegos populares con dinero real',
    'rosa.inv.rule1': '1.Cada jugador invitado que recargue cuenta como válido.',
    'rosa.inv.rule2': '2.Cada recompensa de invitación solo puede cobrarse una vez por jugador.',
    'rosa.inv.rule3':
      '3.Después de recibir todas las recompensas, se reiniciará. Puedes seguir invitando amigos para más recompensas.',
    'rosa.inv.shareCopy':
      '🎉 ¡GANA DINERO AHORA! 🎉\n💸 REGÍSTRATE Y CONSIGUE UN BONO DE $10 A $100!\nRecibe el bono gratis en tu cuenta al registrarte. ¡Rápido y simple!',
    'rosa.inv.valid': 'Válido',
    'rosa.inv.warning':
      'Aviso importante: Para garantizar la imparcialidad en la plataforma, hemos adoptado medidas contra las trampas. Los usuarios que hagan trampas verán sus cuentas suspendidas permanentemente, sus fondos ilícitos congelados y serán responsables ante la ley.',
    'rosa.inv.win200': 'Gana $200',
    'rosa.pop.depositGo': 'Recarga ahora',
    'rosa.pop.depositLead': 'Recibe un {rate} extra\nen tu primera recarga.',
    'rosa.pop.depositTitle': 'PRIMER DEPÓSITO',
    'rosa.pop.registerGo': 'Ir a registrarse',
    'rosa.pop.registerTitle': 'BONO DE REGISTRO',
    'rosa.popup.congrats': '¡Felicidades!',
    'rosa.notice.empty': 'Sin mensajes',
    'rosa.rec.biz.ACTIVITY_REWARD': 'Recompensa de actividad',
    'rosa.rec.biz.DEPOSIT': 'Depósito',
    'rosa.rec.biz.DEPOSIT_REBATE': 'Reembolso de depósito',
    'rosa.rec.biz.GAME_REBATE': 'Reembolso de juego',
    'rosa.rec.biz.GAME_SPIN': 'Apuesta',
    'rosa.rec.biz.GIFT_BONUS': 'Bono de regalo',
    'rosa.rec.biz.MANUAL_CREDIT': 'Ajuste crédito',
    'rosa.rec.biz.MANUAL_DEBIT': 'Ajuste débito',
    'rosa.rec.biz.REDEEM_CODE': 'Código de canje',
    'rosa.rec.biz.REFERRAL_BONUS': 'Bono de referido',
    'rosa.rec.biz.TASK_REWARD': 'Recompensa de tarea',
    'rosa.rec.biz.VIP_BONUS': 'Bono VIP',
    'rosa.rec.biz.WHEEL_BONUS': 'Bono de ruleta',
    'rosa.rec.biz.WITHDRAW': 'Retiro',
    'rosa.rec.biz.WITHDRAW_HOLD': 'Retiro congelado',
    'rosa.rec.biz.WITHDRAW_REFUND': 'Retiro reembolsado',
    'rosa.rec.biz.WITHDRAW_UNHOLD': 'Retiro descongelado',
    'rosa.rec.biz.WUFU_BONUS': 'Bono Wufu',
    'rosa.rec.empty.bets': 'Sin apuestas',
    'rosa.rec.empty.deposit': 'Sin registro de depósito',
    'rosa.rec.empty.moves': 'Sin movimientos',
    'rosa.rec.empty.withdraw': 'Sin datos disponibles',
    'rosa.rec.tab.bets': 'Apuestas',
    'rosa.rec.tab.deposit': 'Recargar',
    'rosa.rec.tab.moves': 'Movimientos',
    'rosa.rec.tab.withdraw': 'Retiro',
    'rosa.records.title': 'Registros',
    'rosa.service.chat': 'Chat en vivo',
    'rosa.service.hours':
      'Tras recibir tu mensaje, nuestro equipo de soporte responderá lo antes posible durante el horario laboral. ¡Gracias por tu paciencia!',
    'rosa.service.unavailable': 'El chat en vivo no está disponible por el momento.',
    'rosa.notice.showAll': 'Mostrar todo.',
    'rosa.rank.empty': 'Sin ranking',
    'rosa.rank.loadFail': 'No se pudo cargar',
    'rosa.rank.me': 'Tu #{rank} · $ {amount}',
    'rosa.rank.monthly': 'Mensual',
    'rosa.rank.noPlayers': 'Sin jugadores',
    'rosa.rank.weekly': 'Semanal',
    'rosa.rank.daily': 'Diario',
    'rosa.sign.empty': 'Sin check-in',
    'rosa.vip.betBonus': 'Bono de Apuesta',
    'rosa.vip.betHintLead': 'Apostá',
    'rosa.vip.betHintTail': 'hoy para recibir cashback mañana',
    'rosa.vip.cashback': 'Cashback diario',
    'rosa.vip.col.bankrupt': 'Bancarrota',
    'rosa.vip.col.level': 'Nivel',
    'rosa.vip.col.monthly': 'Mensual',
    'rosa.vip.col.rescue': 'Rescate',
    'rosa.vip.col.spin': 'Girar',
    'rosa.vip.col.upgrade': 'Mejorar',
    'rosa.vip.col.weekly': 'Semanal',
    'rosa.vip.daily': 'Registro diario',
    'rosa.vip.depBonus': 'Bono de Depósito',
    'rosa.vip.depHintLead': 'Deposite',
    'rosa.vip.depHintTail': 'hoy para recibir cashback mañana',
    'rosa.vip.day': 'DÍA',
    'rosa.vip.loadFail': 'No se pudo cargar VIP',
    'rosa.vip.month': 'MES',
    'rosa.vip.monthly': 'Bono mensual',
    'rosa.vip.rescueHelp': '¿Menos de 1? ¡Ayuda!',
    'rosa.vip.rescueTitle': 'Ayuda por bancarrota',
    'rosa.vip.title': 'Club VIP',
    'rosa.vip.upgrade': 'Bono por subir a VIP',
    'rosa.vip.week': 'SEMANA',
    'rosa.vip.weekly': 'Bono semanal',
    'rosa.vip.win': 'Ganar',
    'rosa.vip.wheelTitle': 'Gira la ruleta',
    'rosa.wheel.claim': 'Solicitar retiro',
    'rosa.wheel.claimed': 'En revisión',
    'rosa.wheel.empty': 'Sin ruleta',
    'rosa.wheel.intro':
      'Inicia sesión a diario para recibir giros gratis. Tras usarlos, puedes conseguir giros adicionales invitando a tus amigos.',
    'rosa.wheel.maxPrize': 'El premio máximo por partida es de $ {n}',
    'rosa.wheel.needVip': 'Requiere VIP {n}',
    'rosa.wheel.noSpins': 'Sin giros',
    'rosa.wheel.prize': 'Premio',
    'rosa.wheel.progress': 'Acumulado $ {n} / $ {m}',
    'rosa.wheel.rule1':
      'Puedes comenzar a retirar cuando el bono acumulado alcance $ {n}, y el bono único máximo puede llegar hasta $ {m}.',
    'rosa.wheel.rule2': 'El evento se reinicia cada 7 días y puedes participar varias veces.',
    'rosa.wheel.rule3': 'Cada usuario puede obtener 1 giro gratis por día.',
    'rosa.wheel.rule4':
      'Después de completar la tarea, debes girar inmediatamente; de lo contrario, se generará una nueva tarea (los giros no se acumulan).',
    'rosa.wheel.rules': 'Reglas',
    'rosa.wheel.spin': 'Girar',
    'rosa.wheel.spinFail': 'No se pudo girar',
    'rosa.wheel.tickets': 'Giros',
    'rosa.wheel.unavailable': 'Ruleta no disponible',
    'rosa.wheel.welcome': 'Bienvenido a la rueda de la fortuna. ¡Reclama tu generoso bono! 🎁',
    'rosa.wheel.winners': 'Ganadores de premios',
  },
  'en-US': {
    'rosa.exitInvite.title': 'Invite 1 friend',
    'rosa.exitInvite.copy': 'Invite a friend who meets the activity requirements to receive the first-tier reward.',
    'rosa.exitInvite.go': 'Invite now',

    'rosa.act.agente': 'Agent',
    'rosa.act.canjear': 'Loss rebate',
    'rosa.act.checkin': 'Check-in',
    'rosa.act.ganar200': 'Win $200',
    'rosa.act.invitacion': 'Invite',
    'rosa.act.misterioso': 'Mystery',
    'rosa.act.promocional': 'Promo',
    'rosa.act.ranking': 'Ranking',
    'rosa.act.ruleta': 'Wheel',
    'rosa.act.semana': 'Weekly',
    'rosa.salary.title': 'VIP Salary',
    'rosa.salary.hero': 'VIP users, claim your upgrade rewards and weekly salary!',
    'rosa.salary.heroSub': 'Deposit to unlock larger rewards',
    'rosa.salary.levelNow': 'Current level: VIP {n}',
    'rosa.salary.upgradeSec': 'Upgrade rewards',
    'rosa.salary.weekSec': 'Weekly salary',
    'rosa.salary.days': 'days',
    'rosa.salary.receive': 'Claim',
    'rosa.salary.received': 'Received',
    'rosa.salary.locked': 'Locked',
    'rosa.salary.history': 'History',
    'rosa.salary.rule1': 'Each week you receive a cash bonus based on your current VIP level.',
    'rosa.salary.rule2': 'Higher VIP means a larger weekly bonus.',
    'rosa.salary.rule3': 'Bonuses can be claimed after 5:00 a.m. every Wednesday.',
    'rosa.salary.rule4': 'The platform reserves final interpretation.',
    'rosa.act.vip': 'VIP',
    'rosa.checkpop.copy': 'Sign in daily to receive rewards.',
    'rosa.checkpop.go': 'Go to Check-in',
    'rosa.casino.empty': 'No games available',
    'rosa.casino.games': 'Games',
    'rosa.casino.loadError': 'Could not load. Please try again.',
    'rosa.casino.noResults': 'No results',
    'rosa.casino.search': 'Search',
    'rosa.casino.searchGame': 'Search games',
    'rosa.casino.title': 'Casino',
    'rosa.search.title': 'Search',
    'rosa.search.prefix': 'Casino',
    'rosa.search.placeholder': 'Game name',
    'rosa.search.minChars': 'Please enter at least 3 characters',
    'rosa.search.history': 'History',
    'rosa.search.clearHistory': 'Clear',
    'rosa.search.recommend': 'Recommended',
    'rosa.search.empty': 'No results',
    'rosa.common.back': 'Back',
    'rosa.common.backTop': 'Back to top',
    'rosa.common.loading': 'Loading…',
    'rosa.common.retryLoad': 'Could not load',
    'rosa.dep.amount': 'amount',
    'rosa.dep.amountMin': 'amount(≥ {min})',
    'rosa.dep.amountRange': 'amount({min} ~ {max})',
    'rosa.dep.bonusOpt': 'Deposit now and get a bonus of up to:',
    'rosa.dep.bonusTip': 'Bonus redeemable after 1x valid bets',
    'rosa.dep.completePay': 'Complete the payment',
    'rosa.dep.kindFirst': 'First deposit',
    'rosa.dep.kindRecharge': 'Reload bonus',
    'rosa.dep.invalidAmount': 'Invalid amount',
    'rosa.dep.invalidPayUrl': 'Invalid payment link',
    'rosa.dep.loadMethodsFail': 'Could not load deposit methods',
    'rosa.dep.methods': 'Deposit methods',
    'rosa.dep.noChannel': 'No deposit channels',
    'rosa.dep.receive': 'You will receive',
    'rosa.dep.records': 'Deposit records',
    'rosa.dep.success': 'Deposit successful',
    'rosa.depRec.accumulated': 'Accumulated deposit:',
    'rosa.depRec.empty': 'No deposit records',
    'rosa.depRec.fail': 'Failed',
    'rosa.depRec.loading': 'Loading...',
    'rosa.depRec.noMore': 'No more data',
    'rosa.depRec.ok': 'Success',
    'rosa.depRec.pending': 'Pending',
    'rosa.depRec.range.last': 'Last {day} days',
    'rosa.depRec.range.seven_days': '7 days',
    'rosa.depRec.range.three_days': '3 days',
    'rosa.depRec.range.today': 'Today',
    'rosa.depRec.valor': 'Value',
    'rosa.footer.community':
      'Welcome to the {brand} community! Share ideas, topics and join respectfully.',
    'rosa.home.catalogError': 'Could not load games. Please try again later.',
    'rosa.home.emptyGames': 'No games available',
    'rosa.home.more': 'More',
    'rosa.lobby.hot': 'Hot',
    'rosa.lobby.new': 'New',
    'rosa.redeem.busy': 'Redeeming…',
    'rosa.redeem.code': 'Redemption code',
    'rosa.redeem.empty': 'Cannot be empty!',
    'rosa.redeem.err.already': 'You already redeemed this code.',
    'rosa.redeem.err.device': 'Device redeem limit reached.',
    'rosa.redeem.err.exhausted': 'This code is sold out.',
    'rosa.redeem.err.expired': 'Code expired or not yet available.',
    'rosa.redeem.err.generic': 'The network connection timed out. Please check your connection.',
    'rosa.redeem.err.invalid': 'Invalid code.',
    'rosa.redeem.err.ip': 'Network redeem limit reached.',
    'rosa.redeem.headline': 'Redeem your bonus code',
    'rosa.redeem.ok': 'Bonus of $ {amount} credited.',
    'rosa.redeem.placeholder': 'Enter your code here',
    'rosa.redeem.submit': 'Redeem',
    'rosa.redeem.title': 'Bonus code',
    'rosa.ticker.withdraw': '{player} just withdrew {amount} $',
    'rosa.wd.amountPlaceholder': 'Please enter the withdrawal amount.',
    'rosa.wd.available': 'Available to withdraw',
    'rosa.wd.fieldAccount': 'Account',
    'rosa.wd.fieldName': 'Enter your name',
    'rosa.wd.history': 'History',
    'rosa.wd.invalidAmount': 'Invalid amount',
    'rosa.wd.loadFail': 'Could not load withdrawal',
    'rosa.wd.note': '$50 Deposit to your personal account',
    'rosa.wd.payPassword': 'Payment password (6 digits)',
    'rosa.wd.records': 'Withdraw records',
    'rosa.wd.rules': 'Rules',
    'rosa.wd.rulesBody':
      'Game withdrawals depend on wagering limits. If you cannot withdraw, play more to increase it. Contact support if you need help.',
    'rosa.wd.spei': 'To withdraw with SPEI, register your SPEI in your bank app.',
    'rosa.wdHist.amount': 'Amount',
    'rosa.wdHist.empty': 'No data available',
    'rosa.wdHist.order': 'Order',
    'rosa.wdHist.refresh': 'Refresh withdrawal status',
    'rosa.wdHist.status': 'Status',
    'rosa.wdHist.time': 'Time',
    'rosa.auth.brandWelcome': 'Welcome to',
    'rosa.auth.err.passwordFormat':
      '6 to 16 characters: letters, numbers, or special characters',
    'rosa.auth.err.passwordRequired': 'Please enter your password',
    'rosa.auth.err.phoneInvalid': 'Incorrect phone number',
    'rosa.auth.err.phoneLength': 'The number must have 10 digits',
    'rosa.auth.err.phoneRequired': 'Please enter your phone number',
    'rosa.auth.err.termsRequired': 'Please confirm this option.',
    'rosa.auth.hasAccount': 'Already have an account?',
    'rosa.auth.hidePassword': 'Hide password',
    'rosa.auth.loginBusy': 'Signing in…',
    'rosa.auth.noAccount': "Don't have an account yet?",
    'rosa.auth.phone': 'Phone number',
    'rosa.auth.password': 'Password',
    'rosa.auth.registerBusy': 'Registering…',
    'rosa.auth.registerGift': 'Sign up +$ 10 ~ 100',
    'rosa.auth.registerGiftAmount': 'Sign up +$ {n}',
    'rosa.auth.registerGiftRange': 'Sign up +$ {min} ~ {max}',
    'rosa.auth.remember': 'Remember password',
    'rosa.auth.showPassword': 'Show password',
    'rosa.auth.slogan': 'We offer you an unmatched gaming experience',
    'rosa.auth.terms': 'I accept all policies, privacy terms and confirm that I am at least 18 years old.',
    'rosa.common.close': 'Close',
    'rosa.common.closeMenu': 'Close menu',
    'rosa.common.copied': 'Copied',
    'rosa.common.copyFail': 'Could not copy',
    'rosa.common.copyId': 'Copy ID',
    'rosa.common.home': 'Home',
    'rosa.common.menu': 'Menu',
    'rosa.float.bonus': 'WhatsApp bonus',
    'rosa.float.promo': 'Deposit promo',
    'rosa.float.social': 'Telegram / WhatsApp',
    'rosa.header.bonus': '+$ 10 ~ 50',
    'rosa.header.bonusAmount': '+$ {n}',
    'rosa.header.bonusRange': '+$ {min} ~ {max}',
    'rosa.header.deposit': 'Deposit',
    'rosa.header.login': 'Log in',
    'rosa.header.message': 'Messages',
    'rosa.header.register': 'Sign up',
    'rosa.menu.addHome': 'Add to home screen',
    'rosa.menu.bonusCode': 'Bonus code',
    'rosa.menu.deposit': 'Deposit',
    'rosa.menu.free200': 'Win $200 free',
    'rosa.menu.support': 'Live support',
    'rosa.menu.withdraw': 'Withdraw',
    'rosa.nav.aria': 'Main navigation',
    'rosa.nav.bonus': 'Bonuses',
    'rosa.nav.deposit': 'Deposit',
    'rosa.nav.personal': 'Profile',
    'rosa.nav.promotions': 'Promos',
    'rosa.nav.withdraw': 'Withdraw',
    'rosa.profile.bets': 'BETS',
    'rosa.profile.currency': 'Currency:',
    'rosa.profile.deposit': 'Deposit',
    'rosa.profile.depositRec': 'Deposit',
    'rosa.profile.withdrawRec': 'Withdraw',
    'rosa.profile.guestHint': 'Please register or log in first.',
    'rosa.profile.guestWelcome': 'Welcome to',
    'rosa.profile.invite': 'Invite chest',
    'rosa.profile.logout': 'Log out',
    'rosa.profile.message': 'Messages',
    'rosa.profile.service': 'Customer service',
    'rosa.profile.title': 'Profile',
    'rosa.profile.wheel': 'Lucky wheel',
    'rosa.cta.activate': 'Activate',
    'rosa.cta.autoGrant': 'Credited automatically',
    'rosa.cta.claim': 'Claim',
    'rosa.cta.claimed': 'Claimed',
    'rosa.cta.claimedVip': 'Received',
    'rosa.cta.enter': 'Enter',
    'rosa.cta.locked': 'Locked',
    'rosa.common.all': 'All',
    'rosa.common.claimFail': 'Could not claim',
    'rosa.common.claimedOk': 'Reward claimed',
    'rosa.common.claimedOkAmount': 'Reward claimed +{amount}',
    'rosa.common.claimedOkCoupon': 'Reward claimed +{n}%',
    'rosa.common.details': 'Details',
    'rosa.common.empty': 'No data',
    'rosa.common.next': 'Next',
    'rosa.common.prev': 'Previous',
    'rosa.promo.empty': 'No activities',
    'rosa.engine.empty.misterioso': 'No mystery bonus',
    'rosa.engine.empty.promocional': 'No promo',
    'rosa.engine.empty.semana': 'No weekly bonus',
    'rosa.engine.day': 'Day {n}',
    'rosa.engine.max': 'Max $ {n}',
    'rosa.engine.level': 'Level {n}',
    'rosa.engine.register': 'Sign-up',
    'rosa.engine.eventDetails': 'Event details:',
    'rosa.engine.goDeposit': 'Deposit now',
    'rosa.engine.reward': 'Reward',
    'rosa.rescue.pageTitle': 'Loss subsidy',
    'rosa.rescue.tabDaily': 'Daily rescue',
    'rosa.rescue.tabWeekly': 'Weekly rescue',
    'rosa.rescue.today': "Today's subsidy",
    'rosa.rescue.hintDaily': 'Available at {h}:00 the next day.',
    'rosa.rescue.hintWeekly': 'Available at {h}:00 on Monday.',
    'rosa.rescue.colLevel': 'Level',
    'rosa.rescue.colLoss': 'Loss amount',
    'rosa.rescue.colRate': 'Subsidy',
    'rosa.rescue.rules': 'Event rules:',
    'rosa.sign.chestHint': 'Check in on consecutive days to unlock a mystery chest: max ???',
    'rosa.sign.collect': 'Collect',
    'rosa.sign.level': 'Current level: VIP{n}',
    'rosa.sign.lockedRound': 'Locked: {n} Check-in round ({days} days total)',
    'rosa.sign.reward': 'Reward',
    'rosa.game.login': 'Please log in',
    'rosa.game.maint': 'Under maintenance.',
    'rosa.game.notFound': 'Game not found',
    'rosa.game.balanceTooLow': 'Available balance is below 1. Deposit before entering.',
    'rosa.guide.congrats': '🎉 Congratulations! 🎉',
    'rosa.guide.win': 'Player [{player}] won {amount} on {game}. Try your luck!',
    'rosa.guide.winPrefix': 'Player [{player}] won ',
    'rosa.guide.winSuffix': ' on {game}. Try your luck!',
    'rosa.inv.hireTitle': 'GROUP ESTÁ CONTRATANDO',
    'rosa.inv.hireLead': 'Buscamos influencers y creadores de contenido',
    'rosa.inv.hireBody':
      'Si eres influencer o creador de contenido y buscas una oportunidad de trabajo estable, de largo plazo y con excelentes ingresos, comunícate con nosotros.',
    'rosa.inv.hireMode': 'MODALIDAD DE TRABAJO',
    'rosa.inv.hireModeBody':
      'Promoción en Instagram y Facebook, además de difusión en canales de WhatsApp y Telegram.',
    'rosa.inv.hireContact': 'CONTACTO',
    'rosa.inv.hireTelegram': 'Telegram: @CCmegaOne',
    'rosa.inv.subtext':
      'Invita a tus amigos a registrarse y completar su recarga para recibir una recompensa de hasta',
    'rosa.inv.tabHow': 'Cómo invitar',
    'rosa.inv.tabDaily': 'Invitación diaria',
    'rosa.inv.agentRank': 'Agent ranking',
    'rosa.inv.chest': 'Chest',
    'rosa.inv.colReward': 'Get rewards',
    'rosa.inv.colValid': 'Invite valid users',
    'rosa.inv.condition': 'condition',
    'rosa.inv.recharge': 'Recharge',
    'rosa.inv.bets': 'Bets',
    'rosa.inv.copy': 'Copy',
    'rosa.inv.copyHint': 'Copy the invite link and send it to your friends.',
    'rosa.inv.copyLink': 'Link copied',
    'rosa.inv.detailLead':
      'Invite your friends and win great prizes! Explore 5000 popular interactive games with us. Join the Partner Program and earn high commissions when your friends register and make their first deposit.',
    'rosa.inv.detailRule':
      'Participation rules: A friend who registers through your exclusive link and completes their first deposit will be added to your valid referrals.',
    'rosa.inv.emailSubject': 'Invitation',
    'rosa.inv.flowInvite': 'Invite',
    'rosa.inv.flowReward': 'Reward of {n}',
    'rosa.inv.guests': 'Invited',
    'rosa.inv.loadFail': 'Could not load invitation',
    'rosa.inv.payoutTip': 'Rewards are distributed at 11:00 the next day.',
    'rosa.inv.people': '{n} person',
    'rosa.inv.peopleMore': '> {n} people',
    'rosa.inv.peopleRange': '{from} - {to} people',
    'rosa.inv.posterHint': 'Scan the QR code to join and start earning together.',
    'rosa.inv.posterLead': 'Register and receive',
    'rosa.inv.posterSave': 'Save image',
    'rosa.inv.posterSaving': 'Saving…',
    'rosa.inv.posterSaved': 'Image downloaded',
    'rosa.inv.posterSaveFail': 'Could not save the image. Please try again.',
    'rosa.inv.posterLabel': 'Invitation image {n}',
    'rosa.inv.posterFriends': 'Help your friends and earn cash rewards.',
    'rosa.inv.posterSub': 'More than 5000 popular real-money games',
    'rosa.inv.rule1': '1.Each invited player who deposits counts as valid.',
    'rosa.inv.rule2': '2.Each invitation reward can be claimed only once per player.',
    'rosa.inv.rule3':
      '3.After all rewards are claimed, it resets. You can keep inviting friends for more rewards.',
    'rosa.inv.shareCopy':
      '🎉 WIN MONEY NOW! 🎉\n💸 SIGN UP AND GET A $10 TO $100 BONUS!\nGet the free bonus in your account when you register. Fast and simple!',
    'rosa.inv.valid': 'Valid',
    'rosa.inv.warning':
      'Important notice: To keep the platform fair, we have anti-cheat measures. Users who cheat will have their accounts permanently suspended, illicit funds frozen, and may be held legally responsible.',
    'rosa.inv.win200': 'Win $200',
    'rosa.pop.depositGo': 'Recharge now',
    'rosa.pop.depositLead': 'Get {rate} extra\non your first recharge.',
    'rosa.pop.depositTitle': 'FIRST DEPOSIT',
    'rosa.pop.registerGo': 'Go to register',
    'rosa.pop.registerTitle': 'SIGN-UP BONUS',
    'rosa.popup.congrats': 'Congratulations!',
    'rosa.notice.empty': 'No messages',
    'rosa.rec.biz.ACTIVITY_REWARD': 'Activity reward',
    'rosa.rec.biz.DEPOSIT': 'Deposit',
    'rosa.rec.biz.DEPOSIT_REBATE': 'Deposit rebate',
    'rosa.rec.biz.GAME_REBATE': 'Game rebate',
    'rosa.rec.biz.GAME_SPIN': 'Bet',
    'rosa.rec.biz.GIFT_BONUS': 'Gift bonus',
    'rosa.rec.biz.MANUAL_CREDIT': 'Manual credit',
    'rosa.rec.biz.MANUAL_DEBIT': 'Manual debit',
    'rosa.rec.biz.REDEEM_CODE': 'Redeem code',
    'rosa.rec.biz.REFERRAL_BONUS': 'Referral bonus',
    'rosa.rec.biz.TASK_REWARD': 'Task reward',
    'rosa.rec.biz.VIP_BONUS': 'VIP bonus',
    'rosa.rec.biz.WHEEL_BONUS': 'Wheel bonus',
    'rosa.rec.biz.WITHDRAW': 'Withdraw',
    'rosa.rec.biz.WITHDRAW_HOLD': 'Withdraw hold',
    'rosa.rec.biz.WITHDRAW_REFUND': 'Withdraw refund',
    'rosa.rec.biz.WITHDRAW_UNHOLD': 'Withdraw unhold',
    'rosa.rec.biz.WUFU_BONUS': 'Wufu bonus',
    'rosa.rec.empty.bets': 'No bets',
    'rosa.rec.empty.deposit': 'No deposit records',
    'rosa.rec.empty.moves': 'No movements',
    'rosa.rec.empty.withdraw': 'No data available',
    'rosa.rec.tab.bets': 'Bets',
    'rosa.rec.tab.deposit': 'Deposit',
    'rosa.rec.tab.moves': 'Movements',
    'rosa.rec.tab.withdraw': 'Withdraw',
    'rosa.records.title': 'Records',
    'rosa.service.chat': 'Live chat',
    'rosa.service.hours':
      'After we receive your message, our support team will reply as soon as possible during business hours. Thank you for your patience!',
    'rosa.service.unavailable': 'Live chat is unavailable at the moment.',
    'rosa.notice.showAll': 'Show all.',
    'rosa.rank.empty': 'No ranking',
    'rosa.rank.loadFail': 'Could not load',
    'rosa.rank.me': 'You #{rank} · $ {amount}',
    'rosa.rank.monthly': 'Monthly',
    'rosa.rank.noPlayers': 'No players',
    'rosa.rank.weekly': 'Weekly',
    'rosa.rank.daily': 'Daily',
    'rosa.sign.empty': 'No check-in',
    'rosa.vip.betBonus': 'Betting bonus',
    'rosa.vip.betHintLead': 'Bet',
    'rosa.vip.betHintTail': 'today to receive cashback tomorrow',
    'rosa.vip.cashback': 'Daily cashback',
    'rosa.vip.col.bankrupt': 'Bankrupt',
    'rosa.vip.col.level': 'Level',
    'rosa.vip.col.monthly': 'Monthly',
    'rosa.vip.col.rescue': 'Rescue',
    'rosa.vip.col.spin': 'Spin',
    'rosa.vip.col.upgrade': 'Upgrade',
    'rosa.vip.col.weekly': 'Weekly',
    'rosa.vip.daily': 'Daily check-in',
    'rosa.vip.depBonus': 'Deposit bonus',
    'rosa.vip.depHintLead': 'Deposit',
    'rosa.vip.depHintTail': 'today to receive cashback tomorrow',
    'rosa.vip.day': 'DAY',
    'rosa.vip.loadFail': 'Could not load VIP',
    'rosa.vip.month': 'MONTH',
    'rosa.vip.monthly': 'Monthly bonus',
    'rosa.vip.rescueHelp': 'Less than 1? Help!',
    'rosa.vip.rescueTitle': 'Bankruptcy help',
    'rosa.vip.title': 'VIP Club',
    'rosa.vip.upgrade': 'VIP upgrade bonus',
    'rosa.vip.week': 'WEEK',
    'rosa.vip.weekly': 'Weekly bonus',
    'rosa.vip.win': 'Win',
    'rosa.vip.wheelTitle': 'Spin the wheel',
    'rosa.wheel.claim': 'Request withdrawal',
    'rosa.wheel.claimed': 'Under review',
    'rosa.wheel.empty': 'No wheel',
    'rosa.wheel.intro':
      'Sign in daily for free spins. After using them, invite friends for extra spins.',
    'rosa.wheel.maxPrize': 'The max prize per spin is $ {n}',
    'rosa.wheel.needVip': 'Requires VIP {n}',
    'rosa.wheel.noSpins': 'No spins',
    'rosa.wheel.prize': 'Prize',
    'rosa.wheel.progress': 'Progress $ {n} / $ {m}',
    'rosa.wheel.rule1':
      'You can withdraw when accumulated bonus reaches $ {n}. The max single prize can reach $ {m}.',
    'rosa.wheel.rule2': 'The event resets every 7 days and you can join again.',
    'rosa.wheel.rule3': 'Each user can get 1 free spin per day.',
    'rosa.wheel.rule4':
      'Spin right after a task; unused spins do not stack and a new task may replace them.',
    'rosa.wheel.rules': 'Rules',
    'rosa.wheel.spin': 'Spin',
    'rosa.wheel.spinFail': 'Could not spin',
    'rosa.wheel.tickets': 'Spins',
    'rosa.wheel.unavailable': 'Wheel unavailable',
    'rosa.wheel.welcome': 'Welcome to the lucky wheel. Claim your bonus! 🎁',
    'rosa.wheel.winners': 'Winners',
  },
  'zh-CN': {
    'rosa.exitInvite.title': '邀请1位好友',
    'rosa.exitInvite.copy': '邀请好友完成活动要求，即可获得第一档奖励。',
    'rosa.exitInvite.go': '立即邀请',

    "rosa.act.agente": "代理",
    "rosa.act.canjear": "亏损返利",
    "rosa.act.checkin": "签到",
    "rosa.act.ganar200": "赢取 $200",
    "rosa.act.invitacion": "邀请奖励",
    "rosa.act.misterioso": "神秘奖励",
    "rosa.act.promocional": "优惠活动",
    "rosa.act.ranking": "排行榜",
    "rosa.act.ruleta": "转盘",
    "rosa.act.semana": "每周奖励",
    "rosa.salary.title": "VIP 周薪",
    "rosa.salary.hero": "VIP 用户请领取升级奖励和周薪！",
    "rosa.salary.heroSub": "充值可解锁更高奖励",
    "rosa.salary.levelNow": "当前等级：VIP {n}",
    "rosa.salary.upgradeSec": "升级奖励",
    "rosa.salary.weekSec": "周薪",
    "rosa.salary.days": "天",
    "rosa.salary.receive": "领取",
    "rosa.salary.received": "已领取",
    "rosa.salary.locked": "未解锁",
    "rosa.salary.history": "领取记录",
    "rosa.salary.rule1": "每周按当前 VIP 等级发放现金奖励。",
    "rosa.salary.rule2": "VIP 越高，周薪越高。",
    "rosa.salary.rule3": "每周三 05:00 后可领取。",
    "rosa.salary.rule4": "平台保留最终解释权。",
    "rosa.act.vip": "VIP",
    "rosa.checkpop.copy": "每日登录即可领取奖励。",
    "rosa.checkpop.go": "前往签到",
    "rosa.casino.empty": "暂无游戏",
    "rosa.casino.games": "款游戏",
    "rosa.casino.loadError": "加载失败，请重试。",
    "rosa.casino.noResults": "暂无搜索结果",
    "rosa.casino.search": "搜索",
    "rosa.casino.searchGame": "搜索游戏",
    "rosa.casino.title": "游戏大厅",
    "rosa.search.title": "搜索",
    "rosa.search.prefix": "Casino",
    "rosa.search.placeholder": "游戏名称",
    "rosa.search.minChars": "请至少输入 3 个字符",
    "rosa.search.history": "历史",
    "rosa.search.clearHistory": "清除",
    "rosa.search.recommend": "推荐",
    "rosa.search.empty": "暂无结果",
    "rosa.common.back": "返回",
    "rosa.common.backTop": "返回顶部",
    "rosa.common.loading": "加载中…",
    "rosa.common.retryLoad": "加载失败",
    "rosa.common.close": "关闭",
    "rosa.common.closeMenu": "关闭菜单",
    "rosa.common.copied": "已复制",
    "rosa.common.copyFail": "复制失败",
    "rosa.common.copyId": "复制 ID",
    "rosa.common.home": "首页",
    "rosa.common.menu": "菜单",
    "rosa.common.all": "全部",
    "rosa.common.claimFail": "领取失败",
    "rosa.common.claimedOk": "奖励已领取",
    "rosa.common.claimedOkAmount": "奖励已领取 +{amount}",
    "rosa.common.claimedOkCoupon": "奖励已领取 +{n}%",
    "rosa.common.details": "详情",
    "rosa.common.empty": "暂无数据",
    "rosa.common.next": "下一页",
    "rosa.common.prev": "上一页",
    "rosa.dep.amount": "金额",
    "rosa.dep.amountMin": "金额（≥ {min}）",
    "rosa.dep.amountRange": "金额（{min} ~ {max}）",
    "rosa.dep.bonusOpt": "立即充值，最高可获赠：",
    "rosa.dep.bonusTip": "完成 1 倍有效投注后可兑换奖励",
    "rosa.dep.completePay": "完成支付",
    "rosa.dep.kindFirst": "首次充值",
    "rosa.dep.kindRecharge": "复充奖励",
    "rosa.dep.invalidAmount": "金额无效",
    "rosa.dep.invalidPayUrl": "支付链接无效",
    "rosa.dep.loadMethodsFail": "充值方式加载失败",
    "rosa.dep.methods": "充值方式",
    "rosa.dep.noChannel": "暂无充值渠道",
    "rosa.dep.receive": "预计到账",
    "rosa.dep.records": "充值记录",
    "rosa.dep.success": "充值成功",
    "rosa.depRec.accumulated": "累计充值：",
    "rosa.depRec.empty": "暂无充值记录",
    "rosa.depRec.fail": "失败",
    "rosa.depRec.loading": "加载中…",
    "rosa.depRec.noMore": "没有更多数据",
    "rosa.depRec.ok": "成功",
    "rosa.depRec.pending": "处理中",
    "rosa.depRec.range.last": "最近 {day} 天",
    "rosa.depRec.range.seven_days": "7 天",
    "rosa.depRec.range.three_days": "3 天",
    "rosa.depRec.range.today": "今天",
    "rosa.depRec.valor": "金额",
    "rosa.footer.community": "欢迎加入 {brand} 社区！请友善交流，分享想法和话题。",
    "rosa.home.catalogError": "游戏加载失败，请稍后重试。",
    "rosa.home.emptyGames": "暂无游戏",
    "rosa.home.more": "更多",
    "rosa.lobby.hot": "热门",
    "rosa.lobby.new": "最新",
    "rosa.redeem.busy": "兑换中…",
    "rosa.redeem.code": "兑换码",
    "rosa.redeem.empty": "不能为空！",
    "rosa.redeem.err.already": "您已兑换过此兑换码。",
    "rosa.redeem.err.device": "已达到设备兑换次数上限。",
    "rosa.redeem.err.exhausted": "此兑换码已被领完。",
    "rosa.redeem.err.expired": "兑换码已过期或尚未生效。",
    "rosa.redeem.err.generic": "网络连接超时，请检查网络。",
    "rosa.redeem.err.invalid": "兑换码无效。",
    "rosa.redeem.err.ip": "已达到当前网络兑换次数上限。",
    "rosa.redeem.headline": "兑换您的奖励码",
    "rosa.redeem.ok": "$ {amount} 奖励已到账。",
    "rosa.redeem.placeholder": "请输入兑换码",
    "rosa.redeem.submit": "兑换",
    "rosa.redeem.title": "奖励兑换码",
    "rosa.ticker.withdraw": "{player} 刚刚提现 {amount} $",
    "rosa.wd.amountPlaceholder": "请输入提现金额。",
    "rosa.wd.available": "可提现金额",
    "rosa.wd.fieldAccount": "账号",
    "rosa.wd.fieldName": "请输入姓名",
    "rosa.wd.history": "历史记录",
    "rosa.wd.invalidAmount": "金额无效",
    "rosa.wd.loadFail": "提现信息加载失败",
    "rosa.wd.note": "$50 存入您的个人账户",
    "rosa.wd.payPassword": "支付密码（6 位数字）",
    "rosa.wd.records": "提现记录",
    "rosa.wd.rules": "规则",
    "rosa.wd.rulesBody": "游戏提现受投注条件限制。如暂时无法提现，请检查所需投注进度。如需帮助，请联系客服。",
    "rosa.wd.spei": "使用 SPEI 提现前，请在银行应用中登记您的 SPEI 信息。",
    "rosa.wdHist.amount": "金额",
    "rosa.wdHist.empty": "暂无数据",
    "rosa.wdHist.order": "订单",
    "rosa.wdHist.refresh": "刷新提现状态",
    "rosa.wdHist.status": "状态",
    "rosa.wdHist.time": "时间",
    "rosa.auth.brandWelcome": "欢迎来到",
    "rosa.auth.err.passwordFormat": "6 至 16 位字符，可包含字母、数字或特殊字符",
    "rosa.auth.err.passwordRequired": "请输入密码",
    "rosa.auth.err.phoneInvalid": "手机号不正确",
    "rosa.auth.err.phoneLength": "手机号须为 10 位数字",
    "rosa.auth.err.phoneRequired": "请输入手机号",
    "rosa.auth.err.termsRequired": "请勾选确认此选项。",
    "rosa.auth.hasAccount": "已有账号？",
    "rosa.auth.hidePassword": "隐藏密码",
    "rosa.auth.loginBusy": "登录中…",
    "rosa.auth.noAccount": "还没有账号？",
    "rosa.auth.phone": "手机号",
    "rosa.auth.password": "密码",
    "rosa.auth.registerBusy": "注册中…",
    "rosa.auth.registerGift": "注册赠送 +$ 10 ~ 100",
    "rosa.auth.registerGiftAmount": "注册赠送 +$ {n}",
    "rosa.auth.registerGiftRange": "注册赠送 +$ {min} ~ {max}",
    "rosa.auth.remember": "记住密码",
    "rosa.auth.showPassword": "显示密码",
    "rosa.auth.slogan": "为您提供独特的游戏体验",
    "rosa.auth.terms": "我接受所有政策及隐私条款，并确认已满 18 周岁。",
    "rosa.float.bonus": "WhatsApp 奖励",
    "rosa.float.promo": "充值优惠",
    "rosa.float.social": "Telegram / WhatsApp",
    "rosa.header.bonus": "+$ 10 ~ 50",
    "rosa.header.bonusAmount": "+$ {n}",
    "rosa.header.bonusRange": "+$ {min} ~ {max}",
    "rosa.header.deposit": "充值",
    "rosa.header.login": "登录",
    "rosa.header.message": "消息",
    "rosa.header.register": "注册",
    "rosa.menu.addHome": "添加到主屏幕",
    "rosa.menu.bonusCode": "奖励兑换码",
    "rosa.menu.deposit": "充值",
    "rosa.menu.free200": "免费赢取 $200",
    "rosa.menu.support": "在线客服",
    "rosa.menu.withdraw": "提现",
    "rosa.nav.aria": "主导航",
    "rosa.nav.bonus": "奖励",
    "rosa.nav.deposit": "充值",
    "rosa.nav.personal": "个人中心",
    "rosa.nav.promotions": "活动",
    "rosa.nav.withdraw": "提现",
    "rosa.profile.bets": "投注",
    "rosa.profile.currency": "余额：",
    "rosa.profile.deposit": "充值",
    "rosa.profile.depositRec": "充值",
    "rosa.profile.withdrawRec": "提现",
    "rosa.profile.guestHint": "请先注册或登录。",
    "rosa.profile.guestWelcome": "欢迎来到",
    "rosa.profile.invite": "邀请宝箱",
    "rosa.profile.logout": "退出登录",
    "rosa.profile.message": "消息",
    "rosa.profile.service": "客服中心",
    "rosa.profile.title": "个人中心",
    "rosa.profile.wheel": "幸运转盘",
    "rosa.cta.activate": "激活",
    "rosa.cta.autoGrant": "自动到账",
    "rosa.cta.claim": "领取",
    "rosa.cta.claimed": "已领取",
    "rosa.cta.claimedVip": "已领取",
    "rosa.cta.enter": "进入",
    "rosa.cta.locked": "未解锁",
    "rosa.promo.empty": "暂无活动",
    "rosa.engine.empty.misterioso": "暂无神秘奖励",
    "rosa.engine.empty.promocional": "暂无优惠活动",
    "rosa.engine.empty.semana": "暂无每周奖励",
    "rosa.engine.day": "第 {n} 天",
    "rosa.engine.max": "最高 $ {n}",
    "rosa.engine.level": "等级 {n}",
    "rosa.engine.register": "注册",
    "rosa.engine.eventDetails": "活动详情：",
    "rosa.engine.goDeposit": "立即充值",
    "rosa.engine.reward": "奖励",
    "rosa.rescue.pageTitle": "亏损补贴",
    "rosa.rescue.tabDaily": "日救济",
    "rosa.rescue.tabWeekly": "周救济",
    "rosa.rescue.today": "今日补贴",
    "rosa.rescue.hintDaily": "次日 {h}:00 可领取。",
    "rosa.rescue.hintWeekly": "周一 {h}:00 可领取。",
    "rosa.rescue.colLevel": "等级",
    "rosa.rescue.colLoss": "亏损金额",
    "rosa.rescue.colRate": "补贴",
    "rosa.rescue.rules": "活动规则：",
    "rosa.sign.chestHint": "连续签到解锁神秘宝箱：最高 ???",
    "rosa.sign.collect": "领取",
    "rosa.sign.level": "当前等级：VIP{n}",
    "rosa.sign.lockedRound": "未解锁：第 {n} 轮签到（共 {days} 天）",
    "rosa.sign.reward": "奖励",
    "rosa.sign.empty": "暂无签到活动",
    "rosa.game.login": "请先登录",
    "rosa.game.maint": "维护中。",
    "rosa.game.notFound": "未找到游戏",
    "rosa.game.balanceTooLow": "可用余额不足 1，请先充值再进入游戏。",
    "rosa.guide.congrats": "🎉 恭喜！🎉",
    "rosa.guide.win": "玩家 [{player}] 在 {game} 中赢得 {amount}。试试您的运气！",
    "rosa.guide.winPrefix": "玩家 [{player}] 赢得了 ",
    "rosa.guide.winSuffix": "，游戏为 {game}。试试您的运气！",
    "rosa.inv.hireTitle": "团队正在招募",
    "rosa.inv.hireLead": "招募达人及内容创作者",
    "rosa.inv.hireBody": "如果您是达人或内容创作者，希望获得稳定、长期且收入可观的合作机会，请联系我们。",
    "rosa.inv.hireMode": "合作方式",
    "rosa.inv.hireModeBody": "在 Instagram、Facebook 以及 WhatsApp 和 Telegram 频道进行推广。",
    "rosa.inv.hireContact": "联系方式",
    "rosa.inv.hireTelegram": "Telegram：@CCmegaOne",
    "rosa.inv.subtext": "邀请好友注册并完成充值，即可获得奖励，最高",
    "rosa.inv.tabHow": "如何邀请",
    "rosa.inv.tabDaily": "每日邀请",
    "rosa.inv.agentRank": "代理排行榜",
    "rosa.inv.chest": "宝箱",
    "rosa.inv.colReward": "获得奖励",
    "rosa.inv.colValid": "邀请有效用户",
    "rosa.inv.condition": "条件",
    "rosa.inv.recharge": "充值",
    "rosa.inv.bets": "流水",
    "rosa.inv.copy": "复制",
    "rosa.inv.copyHint": "复制邀请链接并发送给好友。",
    "rosa.inv.copyLink": "链接已复制",
    "rosa.inv.detailLead": "邀请好友赢取奖励！与我们一起体验 5000 款热门互动游戏。加入合作计划，好友注册并完成首次充值后，您可获得佣金。",
    "rosa.inv.detailRule": "参与规则：好友通过您的专属链接注册并完成首次充值后，将计入有效邀请。",
    "rosa.inv.emailSubject": "邀请",
    "rosa.inv.flowInvite": "邀请",
    "rosa.inv.flowReward": "{n} 奖励",
    "rosa.inv.guests": "已邀请",
    "rosa.inv.loadFail": "邀请信息加载失败",
    "rosa.inv.payoutTip": "奖励于次日 11:00 发放。",
    "rosa.inv.people": "{n} 人",
    "rosa.inv.peopleMore": "超过 {n} 人",
    "rosa.inv.peopleRange": "{from} - {to} 人",
    "rosa.inv.posterHint": "扫描二维码加入，一起参与活动。",
    "rosa.inv.posterLead": "注册即可获得",
    "rosa.inv.posterSave": "保存图片",
    'rosa.inv.posterSaving': '正在保存…',
    'rosa.inv.posterSaved': '图片已下载',
    'rosa.inv.posterSaveFail': '图片保存失败，请重试。',
    'rosa.inv.posterLabel': '邀请海报 {n}',
    'rosa.inv.posterFriends': '帮助好友，一起赢取现金奖励。',
    "rosa.inv.posterSub": "超过 5000 款热门真钱游戏",
    "rosa.inv.rule1": "1. 每位完成充值的受邀玩家计为有效邀请。",
    "rosa.inv.rule2": "2. 每位玩家的邀请奖励仅可领取一次。",
    "rosa.inv.rule3": "3. 全部奖励领取后会重置，您可继续邀请好友获得奖励。",
    "rosa.inv.shareCopy": "🎉 立即赢取奖励！🎉\n💸 注册赠送 $10 至 $100！\n注册即可获得账户奖励，快捷简单！",
    "rosa.inv.valid": "有效",
    "rosa.inv.warning": "重要提示：为保障平台公平，我们设有反作弊措施。作弊用户将被永久封禁，违规资金被冻结，并可能承担法律责任。",
    "rosa.inv.win200": "赢取 $200",
    "rosa.pop.depositGo": "立即充值",
    "rosa.pop.depositLead": "首次充值\n额外赠送 {rate}。",
    "rosa.pop.depositTitle": "首充奖励",
    "rosa.pop.registerGo": "前往注册",
    "rosa.pop.registerTitle": "注册奖励",
    "rosa.popup.congrats": "恭喜！",
    "rosa.notice.empty": "暂无消息",
    "rosa.notice.showAll": "查看全部。",
    "rosa.rec.biz.ACTIVITY_REWARD": "活动奖励",
    "rosa.rec.biz.DEPOSIT": "充值",
    "rosa.rec.biz.DEPOSIT_REBATE": "充值返利",
    "rosa.rec.biz.GAME_REBATE": "游戏返水",
    "rosa.rec.biz.GAME_SPIN": "投注",
    "rosa.rec.biz.GIFT_BONUS": "赠送奖励",
    "rosa.rec.biz.MANUAL_CREDIT": "人工加款",
    "rosa.rec.biz.MANUAL_DEBIT": "人工扣款",
    "rosa.rec.biz.REDEEM_CODE": "兑换码奖励",
    "rosa.rec.biz.REFERRAL_BONUS": "邀请奖励",
    "rosa.rec.biz.TASK_REWARD": "任务奖励",
    "rosa.rec.biz.VIP_BONUS": "VIP 奖励",
    "rosa.rec.biz.WHEEL_BONUS": "转盘奖励",
    "rosa.rec.biz.WITHDRAW": "提现",
    "rosa.rec.biz.WITHDRAW_HOLD": "提现冻结",
    "rosa.rec.biz.WITHDRAW_REFUND": "提现退回",
    "rosa.rec.biz.WITHDRAW_UNHOLD": "提现解冻",
    "rosa.rec.biz.WUFU_BONUS": "五福奖励",
    "rosa.rec.empty.bets": "暂无投注记录",
    "rosa.rec.empty.deposit": "暂无充值记录",
    "rosa.rec.empty.moves": "暂无账变记录",
    "rosa.rec.empty.withdraw": "暂无提现记录",
    "rosa.rec.tab.bets": "游戏记录",
    "rosa.rec.tab.deposit": "充值",
    "rosa.rec.tab.moves": "账变记录",
    "rosa.rec.tab.withdraw": "提现",
    "rosa.records.title": "记录",
    "rosa.service.chat": "在线客服",
    "rosa.service.hours": "收到您的消息后，客服将在工作时间内尽快回复，感谢您的耐心等待！",
    "rosa.service.unavailable": "在线客服暂不可用。",
    "rosa.rank.empty": "暂无排行",
    "rosa.rank.loadFail": "加载失败",
    "rosa.rank.me": "您排名第 {rank} · $ {amount}",
    "rosa.rank.monthly": "月榜",
    "rosa.rank.noPlayers": "暂无玩家",
    "rosa.rank.weekly": "周榜",
    "rosa.rank.daily": "日榜",
    "rosa.vip.betBonus": "投注奖励",
    "rosa.vip.betHintLead": "今日投注",
    "rosa.vip.betHintTail": "，明日可领取返现",
    "rosa.vip.cashback": "每日返现",
    "rosa.vip.col.bankrupt": "破产救济",
    "rosa.vip.col.level": "等级",
    "rosa.vip.col.monthly": "月奖励",
    "rosa.vip.col.rescue": "救济",
    "rosa.vip.col.spin": "转盘",
    "rosa.vip.col.upgrade": "升级奖励",
    "rosa.vip.col.weekly": "周奖励",
    "rosa.vip.daily": "每日签到",
    "rosa.vip.depBonus": "充值奖励",
    "rosa.vip.depHintLead": "今日充值",
    "rosa.vip.depHintTail": "，明日可领取返现",
    "rosa.vip.day": "日",
    "rosa.vip.loadFail": "VIP 信息加载失败",
    "rosa.vip.month": "月",
    "rosa.vip.monthly": "月奖励",
    "rosa.vip.rescueHelp": "不足 1？获取帮助！",
    "rosa.vip.rescueTitle": "破产救济",
    "rosa.vip.title": "VIP 俱乐部",
    "rosa.vip.upgrade": "VIP 升级奖励",
    "rosa.vip.week": "周",
    "rosa.vip.weekly": "周奖励",
    "rosa.vip.win": "赢取",
    "rosa.vip.wheelTitle": "幸运转盘",
    "rosa.wheel.claim": "申请提现",
    "rosa.wheel.claimed": "审核中",
    "rosa.wheel.empty": "暂无转盘活动",
    "rosa.wheel.intro": "每日登录可获免费转盘次数，用完后可邀请好友获得额外次数。",
    "rosa.wheel.maxPrize": "单次最高奖励 $ {n}",
    "rosa.wheel.needVip": "需要 VIP {n}",
    "rosa.wheel.noSpins": "暂无次数",
    "rosa.wheel.prize": "奖品",
    "rosa.wheel.progress": "进度 $ {n} / $ {m}",
    "rosa.wheel.rule1": "累计奖励达到 $ {n} 后可提现，单次最高奖励 $ {m}。",
    "rosa.wheel.rule2": "活动每 7 天重置，可重新参加。",
    "rosa.wheel.rule3": "每位用户每天可获得 1 次免费转盘机会。",
    "rosa.wheel.rule4": "完成任务后请及时使用次数，未使用次数不会累加，新任务可能替换旧任务。",
    "rosa.wheel.rules": "规则",
    "rosa.wheel.spin": "开始转盘",
    "rosa.wheel.spinFail": "转盘失败",
    "rosa.wheel.tickets": "次数",
    "rosa.wheel.unavailable": "转盘暂不可用",
    "rosa.wheel.welcome": "欢迎来到幸运转盘，领取您的奖励！🎁",
    "rosa.wheel.winners": "获奖名单"
},
};
